import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import Link from '@mui/material/Link'
import HelpIcon from 'components/atoms/HelpIcon'

const linkText = ({ camper, loading, loggedIn }) => {
  if (loading) {
    return 'Logging in…'
  }

  if (loggedIn) {
    return 'Loading…'
  }

  return 'Click here to enter Virtual Camp!'
}

const LogInCamperLink = ({
  onClickLogIn,
  onClickHelp,
  camper,
  loading,
  loggedIn
}) => {
  return (
    <Box display='flex' alignItems='center' component='span'>
      <Link href='#' onClick={onClickLogIn}>
        {linkText({ camper, loading, loggedIn })}
      </Link>
      <HelpIcon toolTip='How it works' onClick={onClickHelp} />
    </Box>
  )
}

export default LogInCamperLink
